import React, { Component } from 'react';
import commonUtil from '../../utils/commonUtil';
import { connect } from 'react-redux';
import GiftListConfigureWap from '../../pages/eventManagement/page/GiftList/wapComponents/GiftListConfigureWap';
import NotificationWrapper from '../GRHeader/notifications';
import EventIconWithLoader from '../EventIcon/EventIconWithLoader';

class EventCardProfile extends Component {
    render() {

        // const { initialJson, onItemClick, isactiveItem, selectedTheme, selectedImage1, selectedImage2, eventTxtValue, eventDateValue, icon, ownerName, coOwnerName, CelebrityName, message , lables, eventInfo : { user1firstName , user2firstName , eventName , eventDate, eventId}={}, userInfo, } = this.props;
        const { initialJson, onItemClick, isactiveItem, selectedTheme, icon, ownerName, coOwnerName, CelebrityName, message , lables, eventInfo : { user1firstName , user2firstName , eventName , eventDate, eventId, eventBackground, imageUrl, imageURL}={}, userInfo , isGuestViewListPage = false } = this.props;

        let bgImage = selectedTheme?.banner_texture?.url ?? '';
        let eventBgImage = eventBackground ? eventBackground : bgImage;
        let bgUrlCardHeader = eventBgImage;
        let imgUrl = imageUrl || imageURL || '';
        let eventImage = imgUrl ? imgUrl : icon;
        const imageFormatValid = commonUtil.checkImageURLFormat(eventImage);
    
        let eventLogo = eventImage;
        bgUrlCardHeader = bgUrlCardHeader ? bgUrlCardHeader : commonUtil.getAssetURL() + '/images/pattern/Elegancia.png';
        eventLogo = eventLogo ? eventLogo : commonUtil.getAssetURL() + '/images/Intersect.svg';

        const color200 = selectedTheme?.color_200 ?? '#A1A1A1';
        const color500 = selectedTheme?.color_500 ?? '#333333';
        const eventType = this.props.eventInfo?.eventType || '';
        let formattedDate = "";
        if (eventDate && typeof eventDate === "string" && eventDate.includes("-")) {
            const [year, month, day] = eventDate.split("-");
            if (year && month && day) {
                formattedDate = `${day}/${month}/${year}`;
            }
        }else if (eventDate && typeof eventDate === "string" && eventDate.includes("/")) {
            const [day, month, year] = eventDate.split("/");
            if (year && month && day) {
                formattedDate = `${day}/${month}/${year}`;  
            }
        }

        return (
          <div className='event-card' style={{ backgroundColor: color500 }}>
            <div className='card-header'>
              <div
                className={`event-header-image ${eventBackground ? 'removeOpacity' : ''}`}
                style={{ backgroundImage: `url(${bgUrlCardHeader})` }}
              ></div>
              {!isGuestViewListPage && (
                <div className='icon-btn icon-left'>
                  <GiftListConfigureWap
                    initialJson={initialJson}
                    onItemClick={(id) => {
                      onItemClick(id);
                    }}
                    isactiveItem={isactiveItem}
                    giftAvailable={this.props.giftAvailable}
                    isAgent={this.props.isAgent}
                  />
                </div>
              )}
              {!isGuestViewListPage && (
                <div className='icon-btn icon-right'>
                    <NotificationWrapper eventId={eventId}/>
                  </div>
              )}
              <div className='event-logo'>
                <EventIconWithLoader  
                  event_id={eventId}
                  event_icon={icon}
                  event_theme_color={color500}
                  event_image={!imageFormatValid && imgUrl?.trim() !== '' && imgUrl}
                  icon_width={'120px'}
                  icon_height={'120px'}
                />
              </div>
            </div>

            <div className='card-body'>
              <div className='event-name'>{eventName ? eventName : ''}</div>
              
              {isGuestViewListPage ? (<div className ="cardprofile-eventdate-eventtype-container">
              <div className='event-txt event-calender-txt'>
                <i className='icon-calendar-white'></i> &nbsp;
                {formattedDate ? formattedDate : ''}
              </div>
              <div className="card-eventtypeicon-container">
                <div className="card-svg-container">
  <div
    className='card-event-type-icon'
    role="img"
    aria-label='event-type-icon'
    style={{
      maskImage: `url('/assets/common/images/svgs/${encodeURIComponent(
        commonUtil.convertSpanishToEnglishChars(eventType),
      )}.svg')`,
      WebkitMaskImage: `url('/assets/common/images/svgs/${encodeURIComponent(
        commonUtil.convertSpanishToEnglishChars(eventType),
      )}.svg')`,
      backgroundColor: '#FFFFFF',
      display: 'inline-block',
      maskSize: 'contain',
      WebkitMaskSize: 'contain',
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
    }}
  />
</div>
                <span className="card-eventtype-txt">{eventType}</span>
              </div>
              </div>) : (<div className='event-txt event-calender-txt'>
                <i className='icon-calendar-white'></i> &nbsp;
                {formattedDate ? formattedDate : ''}
              </div>)}
              {message ? <div className='event-message'>{message}</div> : null}
              <div className='event-owner'>
                <div>
                  {userInfo &&
                    Array.isArray(userInfo) &&
                    userInfo
                      .filter(
                        (user) =>
                          user.hasPermission === true &&
                        user.primaryOwner === 'true'
                      )
                      .map((user, index) => (
                        <div key={index} className='event-owner-txt'>
                          {user.firstName} {user.lastName} {user.motherName}
                        </div>
                      ))}
                </div>
                <div>
                  {userInfo &&
                    Array.isArray(userInfo) &&
                    userInfo
                      .filter(
                        (user) =>
                          user.coowner === true || user.coowner === 'true' &&
                         user.primaryOwner === "false",
                      )
                      .map((user, index) => (
                        <div key={index} className='event-owner-txt'>
                          {user.firstName} {user.lastName} {user.motherName}
                        </div>
                      ))}
                </div>
                <div>
                  {userInfo &&
                    Array.isArray(userInfo) &&
                    userInfo
                      .filter(
                        (user) =>
                          user.celebrity === true &&
                          (!user?.coowner || user.coowner === 'false') &&
                           user.primaryOwner === 'false',
                      )
                      .map((user, index) => (
                        <div key={index} className='event-owner-txt'>
                          {user.firstName} {user.lastName} {user.motherName}
                        </div>
                      ))}
                </div>
              </div>
              <div className='event-txt event-number'>
                <span>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    'adminpage.regalosregistrados.nombreEvent.label',
                  )}
                  :&nbsp;
                </span>
                <span>{eventId}</span>
              </div>
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { selectedImage1, selectedImage2, eventTxtValue, eventDateValue } = state?.createEvent ?? {};

    return {
        selectedImage1,
        selectedImage2,
        eventTxtValue,
        eventDateValue,
    };
};

export default connect(mapStateToProps)(EventCardProfile);